import { Select, useMantineTheme } from "@mantine/core";
import { useEffect, useState } from "react";

const CSelect = (props) => {
  const theme = useMantineTheme();
  const [error, setError] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (props.error) {
      setError(props.error);
    }
  }, [props.error]);
  return (
    <>
      <div className={`relative ${props.className}`}>
        <div
          className={`c-place-holder absolute text-textGrey bg-brandGrey ${
            isFocused || props.value ? "focused" : ""
          }`}
        >
          {props.placeholder}
        </div>
        <Select
          {...{ ...props, placeholder: "", className: "" }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          styles={{
            input: {
              height: 44,
              background: theme.colors.brandGrey,
              borderColor: theme.colors.brandGrey2,
              "&::placeholder": {
                color: theme.colors.textGrey,
              },
            },
          }}
          iconWidth={46}
        />
      </div>

      <div
        className={`custom-error text-red-500 text-[12px]  ${
          props.error ? "show-c" : "hidden-c"
        } `}
      >
        <div className={`  overflow-hidden`}>{error}</div>
      </div>

      <style jsx global>{`
        .mantine-Input-wrapper {
          margin-bottom: calc(0.625rem / 2) !important;
        }
        .mantine-InputWrapper-error {
          display: none;
        }
        .custom-error.show-c div {
          height: 16px;
          transition: all 0.5s;
        }
        .custom-error.hidden-c div {
          height: 0px;
          transition: all 0.5s;
        }
        .mantine-Select-rightSection svg {
          height: 26px;
          width: 26px;
          fill: currentColor;
          color: ${theme.colors.textGrey} !important;
        }
      `}</style>
    </>
  );
};

export default CSelect;
